import { selectors, useUserPreferences } from 'modules/common';
import { domain } from 'modules/data';
import { useDispatch } from 'modules/react-redux';
import { useCallback, useMemo } from 'react';
import { amplitudeService } from 'services/amplitude';

import { showNewReportPopup } from '../../actions';
import { sortingOptions } from './ReportsListToolbar.constants';
import { ReportListSorting } from './ReportsListToolbar.types';

export const useReportCreation = (company: selectors.types.ExpandedCompany, reportType: domain.ReportType) => {
    const dispatch = useDispatch();

    return useCallback(() => {
        dispatch(showNewReportPopup({ companyId: company.id, reportType }));

        amplitudeService.sendData('reports: add new report');
    }, [company.id, dispatch, reportType]);
};

export const useReportsSorting = () => {
    const [activeSortingOptionId, setActiveSortingOptionId] = useUserPreferences(
        'reports.Dashboard/ActiveSorting',
        ReportListSorting.ReportName
    );

    const activeSortingOption = useMemo(
        () => sortingOptions.find((option) => option.id === activeSortingOptionId) || null,
        [activeSortingOptionId]
    );

    return { sortingOptions, activeSortingOption, setActiveSortingOptionId };
};
